export default [
  {
    date_terminated: '',
    name: 'FIRST TIME MORTGAGE',
    type: 'Creditor',
    date_added: '05/14/2007',
    uri: 'https://ecf-test.azb.uscourts.gov/cgi-bin/FilerQry.pl?828211101082837-L_ShowDktSummaryList_1-0-55-10488-2644',
  },
  {
    type: 'Trustee',
    date_added: '02/19/2007',
    date_terminated: '07/02/2007',
    name: 'DIANE MANN',
    uri: 'https://ecf-test.azb.uscourts.gov/cgi-bin/FilerQry.pl?828211101082837-L_ShowDktSummaryList_1-0-11-3664-2644',
  },
  {
    name: 'Joseph Wayne Sample',
    date_terminated: '',
    date_added: '02/19/2007',
    type: 'Debtor',
    uri: 'https://ecf-test.azb.uscourts.gov/cgi-bin/FilerQry.pl?828211101082837-L_ShowDktSummaryList_1-0-3-7914-2644',
  },
  {
    name: 'Sarah Lynn Sample',
    date_terminated: '',
    date_added: '02/19/2007',
    type: 'Joint Debtor',
    uri: 'https://ecf-test.azb.uscourts.gov/cgi-bin/FilerQry.pl?828211101082837-L_ShowDktSummaryList_1-0-5-7915-2644',
  },
  {
    uri: 'https://ecf-test.azb.uscourts.gov/cgi-bin/FilerQry.pl?828211101082837-L_ShowDktSummaryList_1-0-8-1418-2644',
    type: 'U.S. Trustee',
    date_added: '02/19/2007',
    date_terminated: '',
    name: 'U.S. Trustee\'s Office',
  }];



// WEBPACK FOOTER //
// ./src/components/case/filers/filersArray.js